import { SortOptions } from '~src/spacesPlatform/models/sort/CommonSortOptions';
import { Order } from '~src/spacesPlatform/models/sort/Order';
import { OptionsDictionary } from '~src/spacesPlatform/models/sort/SortOptionDefinitions';
import { IOrderClause } from '~src/spacesPlatform/serverApi/types/IOrderClause';

import { OrderKeys } from '../../../../spacesPlatform/models/OrderKeys';

export const siteUserContentDefaultSortOrder: IOrderClause[] = [Order.asc(OrderKeys.name)];

export const siteUserContentSortOptions: OptionsDictionary = {
  // Mixed Content does not support relevance and owner sort does not make sense on the user space
  'name': SortOptions.name,
  'type': SortOptions.type,
  'updated': SortOptions.updated
};
